import { render, staticRenderFns } from "./MediaRelated.vue?vue&type=template&id=6ea311bd&scoped=true&"
import script from "./MediaRelated.vue?vue&type=script&lang=js&"
export * from "./MediaRelated.vue?vue&type=script&lang=js&"
import style0 from "./MediaRelated.vue?vue&type=style&index=0&id=6ea311bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea311bd",
  null
  
)

export default component.exports